
import CryptoJS from 'crypto-js';


export class PolymerCrypto {
  private static keySize = 256;
  private static iterations = 16;
  private static secretKey = "IJJH8ODPg8LstEOm8gh5T32md/v83vsgOegkE3XDd/H1pa+v9SjGj9EpwY88U2gb";
  private static salt = "mtEwL5nGnn9nUNJeKhlAFmS9GiaG2ehLBNf0g5ZkiRZjazft3+0euBX4EE9/Lt5J";


  static encryption = (msg?: string) => {
    
    if(!msg){
      return '';
    }
    // Generate IV (16 Bytes)
    const iv = CryptoJS.lib.WordArray.create(undefined, 16);

    // Generate key
    let key = this.generateKey(this.secretKey, this.salt);
    
    const encrypted = CryptoJS.AES.encrypt(
      msg,
      key,
      {
          iv: iv,
          padding: CryptoJS.pad.Pkcs7,
          mode: CryptoJS.mode.CBC
      }
    );

    return btoa(
        atob(CryptoJS.enc.Base64.stringify(iv)) +
        atob(encrypted.toString())
    );

  }

  static decryption = (msg:string) => {
    
    try{
      if(!msg){
        return '';
      }
      
      const decoded_msg = atob(msg).toString();
      const encrypted_iv = btoa(decoded_msg.slice(0,16));
      const encrypted_msg =  btoa(decoded_msg.slice(16));
      const iv_string = CryptoJS.enc.Base64.parse(encrypted_iv).toString();
      const msg_string = CryptoJS.enc.Base64.parse(encrypted_msg).toString();

      const ciphertext:any = CryptoJS.enc.Hex.parse(msg_string);

      let key = this.generateKey(this.secretKey, this.salt);

      const decrypt = CryptoJS.AES.decrypt(
        {ciphertext:ciphertext} as any,
        key,
        {
            iv: CryptoJS.enc.Hex.parse(iv_string),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        }
      );
      const plaintext = CryptoJS.enc.Utf8.stringify(decrypt);

      return plaintext;
    }catch(error){
      return msg;
    }
  }


  static generateKey = (secret: string, salt: string) => {
    const config = {
      keySize: this.keySize / 32,
      iterations: this.iterations,
      hasher: CryptoJS.algo.SHA256
    }

    return CryptoJS.PBKDF2(secret, CryptoJS.enc.Utf8.parse(salt), config)
  }
  
}

